import script from "./PostInvestTodo.vue?vue&type=script&setup=true&lang=js"
export * from "./PostInvestTodo.vue?vue&type=script&setup=true&lang=js"

import "./PostInvestTodo.vue?vue&type=style&index=0&id=3ddc7a89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddc7a89"]])

export default __exports__